import { compose, lifecycle } from "recompose";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { fetchApi } from "core/api/hoc";
import { parse } from "query-string";
import { createLoadingSelector, createErrorsSelector } from "core/helpers";
import * as api from "modules/user/onboarding/api";
import * as authApi from "modules/user/auth/api";
import * as referralApi from "modules/referral/api";
import * as authActions from "modules/user/auth/actions";
import * as hoc from "modules/user/onboarding/hoc";
import * as selectors from "modules/user/onboarding/selectors";
import * as authselectors from "modules/user/auth/selectors";
import * as referralSelectors from "modules/referral/selectors";

import { either } from "ramda";

import View from "./View";

export default compose(
  hoc.unonboarded,
  fetchApi(api.getWizard, {
    selector: selectors.getWizardApi,
    cache: true
  }),
  connect(
    createStructuredSelector({
      updateWizardApi: selectors.updateWizardApi,
      step: selectors.getStep,
      questions: selectors.getQuestions,
      initialValues: selectors.getInitialValues,
      validationSchema: selectors.getValidationSchema,
      errors: createErrorsSelector(selectors.updateWizardApi),
      offer: either(selectors.claimDiscount, authselectors.checkUserDiscount),
      referralDiscount: referralSelectors.acceptInvitation,
      isLoading: createLoadingSelector(selectors.getWizardApi)
    }),
    {
      onSubmit: values =>
        api.updateWizard.request({
          body: values
        }),
      onLogout: authActions.signOut,
      claimDiscount: code => api.claimDiscount.request({ code }),
      checkUserDiscount: () => authApi.checkUserDiscount.request(),
      acceptInvitation: key => referralApi.acceptInvitation.request({ key })
    }
  ),
  lifecycle({
    componentDidMount() {
      const {
        location,
        claimDiscount,
        checkUserDiscount,
        acceptInvitation
      } = this.props;
      const code = parse(location.search).code;
      const referral_key = parse(location.search).referral_key;
      if (code) {
        checkUserDiscount();
        claimDiscount(code);
        return;
      }
      if (referral_key) return acceptInvitation(referral_key);
      return checkUserDiscount();
    }
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/ProfileSetup/Provider.js